module.exports = __webpack_public_path__ + "img/i-3.bb2f475b.svg";